module.exports = __webpack_public_path__ + "static/media/upload.d2978b78.svg";